import { Link } from "react-router-dom";
import { ArrowUpRight, Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
import { PORTAL_URL, EMAIL, PHONE } from "@/lib/site";

const COLS = [
  {
    title: "Company",
    links: [
      ["Tuning Files", "/tuning-files"],
      ["Tuning Database", "/tuning-database"],
      ["Truck & HGV Tuning", "/tuning-database/trucks"],
      ["Agricultural Tuning", "/tuning-database/agriculture"],
      ["Tuning Tools", "/tuning-tools"],
      ["Become a Dealer", "/become-a-dealer"],
      ["About", "/about"],
      ["Contact", "/contact"],
    ],
  },
  {
    title: "Shop",
    links: [
      ["Alientech", "/alientech-kess3"],
      ["AutoTuner", "/autotuner"],
      ["Magic Motorsport", "/tuning-tools/magic-motorsport"],
      ["Magicmotorsport FLEX", "/magicmotorsport-flex"],
      ["Dimsport", "/tuning-tools/dimsport"],
      ["Used Equipment", "/tuning-tools/used-equipment"],
      ["Accessories", "/tuning-tools/accessories"],
      ["Subscriptions & Updates", "/tuning-tools/subscriptions"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/legal/privacy-policy"],
      ["Terms & Conditions", "/legal/terms-and-conditions"],
      ["Cookie Policy", "/legal/cookie-policy"],
      ["Returns Policy", "/legal/returns-policy"],
      ["Delivery Information", "/legal/delivery-information"],
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface">
      <div className="container-regal py-14 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src="/assets/logo/logo-full.webp" alt="Regal Tuning" data-testid="footer-logo" className="h-16 w-auto rounded-lg bg-[#07080A] px-4 py-2" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-400">
              Professional ECU calibration, genuine tuning equipment and technical support for the worldwide tuning industry. Trusted by 1,000+ dealers for over 20 years.
            </p>
            <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-file-portal-link" className="mt-7 inline-flex items-center gap-2 border border-regal-amber px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.18em] text-regal-amber hover:bg-regal-amber hover:text-void transition-colors duration-300">
              File Portal <ArrowUpRight size={14} />
            </a>
            <div className="mt-8 flex gap-3">
              {[[Facebook, "facebook"], [Instagram, "instagram"], [Youtube, "youtube"], [Linkedin, "linkedin"]].map(([Icon, name]) => (
                <a key={name} href="#" aria-label={name} data-testid={`social-${name}`} className="grid h-10 w-10 place-items-center border border-line text-neutral-400 hover:border-regal-amber hover:text-regal-amber transition-colors duration-300">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="overline-label mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-neutral-400 hover:text-regal-amber transition-colors duration-300">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="lg:col-span-2">
            <p className="overline-label mb-5">Contact</p>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li data-testid="footer-phone">{PHONE}</li>
              <li data-testid="footer-email">{EMAIL}</li>
              <li>Mon–Fri 9:00–17:30 GST (UTC+4)</li>
              <li>United Arab Emirates</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-line pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-xs text-neutral-500" data-testid="footer-legal-line">© {new Date().getFullYear()} Regal Tuning. All rights reserved. United Arab Emirates.</p>
          <p className="font-mono text-xs text-neutral-600">PROFESSIONAL USE ONLY — MOTORSPORT &amp; OFF-ROAD CALIBRATIONS</p>
        </div>
      </div>
    </footer>
  );
}
